<div class="item" *ngFor="let item of content">
  <span class="title" *ngIf="!!item?.title">{{item.title}}</span>
  <div class="menu-item{{ option.class ? ' ' + option.class : '' }}" *ngFor="let option of item.options"
    (click)="optionClick(option)">
    <div class="menu-separator" *ngIf="option.separator"></div>
    <bdr-icon class="menu-item-icon" *ngIf="option.icon" [icon]="option.icon" [esir]="true"></bdr-icon>
    <span class="menu-item-caption">{{ option.caption }}</span>
  </div>
</div>